import React, { useEffect, useState } from 'react';

//styling
import './index.css';

const Count = props => {
  // label of counter
  // number to increment to
  // duration of count in seconds
  const {image,label, number, duration } = props.data

  // number displayed by component
  const [count, setCount] = useState("0")

  useEffect(() => {
    let start = 0;
    // first three numbers from props
    const end = parseInt(number.substring(0,3))
    // if zero, return
    if (start === end) return;

    // find duration per increment
    let totalMilSecDur = parseInt(duration);
    let incrementTime = (totalMilSecDur / end) * 1000;

    // timer increments start counter 
    // then updates count
    // ends if start reaches end
    let timer = setInterval(() => {
      start += 1;
      setCount(String(start) + number.substring(3))
      if (start === end) clearInterval(timer)       
    }, incrementTime);

    // dependency array
  }, [number, duration]);

  return (
    <div className='count-image-content-container-main'>
    <div className='count-image-content-container'>
      <div className='count-image-container'>
        <img src={image} alt="" className='count-image' />
        </div>
        <div> 
          <h1 className='count-heading'>{count}+</h1>
          <p className='count-paragraph'>{label}</p>
      </div>
    </div>
  </div>
  );
}

export default Count;